export default __webpack_public_path__ + "static/media/email.87d00e84.svg";